import { Row, Col, Typography, Grid } from "antd";
import { FC } from "react";
import KPI from "../KPI";
import NumericValue from "../NumericValue";

import styles from "./KPIOverview.module.less";

const { Text } = Typography;

export interface KPIOverviewProps {
  /**
   * Header texts
   */
  headers: {
    title: string;
    current: string;
    start?: string;
    target: string;
  };
  /**
   * KPI type
   */
  KPIType: string;
  /**
   * Acquisition Method
   */
  acquisitionMethod: string;
  current: {
    /**
     * Current value loading
     */
    isLoading: boolean;
    /**
     * Current Unit
     */
    unit: string;
    /**
     * Score card value
     */
    scoreCardValue?: number;
  };
  /**
   * Target value
   */
  targetValue: number;
  /**
   * Past
   */
  past?: JSX.Element;
}

/**
 * KPIOverview
 */
const KPIOverview: FC<KPIOverviewProps> = ({
  headers,
  KPIType,
  acquisitionMethod,
  current,
  targetValue,
  past
}) => {
  const { md } = Grid.useBreakpoint();

  return (
    <Row wrap={!md} justify="space-between" gutter={[0, 12]}>
      <Col md={12} span={past ? 24 : 12}>
        <Text type="secondary">{headers.title}</Text>
        <KPI name={KPIType} acquisitionMethod={acquisitionMethod} />
      </Col>
      <Col className={styles.Value}>
        <Text type="secondary">{headers.current}</Text>
        <NumericValue
          highlighted
          isLoading={current.isLoading}
          value={current.scoreCardValue}
          unit={current.unit}
        />
      </Col>
      {past && (
        <Col className={styles.Value}>
          <Text type="secondary">{headers?.start}</Text>
          {past}
        </Col>
      )}
      <Col className={styles.Value}>
        <Text type="secondary">{headers.target}</Text>
        <NumericValue value={targetValue} unit={current.unit} />
      </Col>
    </Row>
  );
};

export default KPIOverview;
